//这里处理样式类放回公共方法
import { isCardID, isCardIDTwo } from './utils.js'
import { numberCardType, normalType } from '@/components/fromDesigner/compon/regularFrom/fileRegular.js'
export function retClassName (e, isOne, onlyTitle, value, othersVal) {
  if (Number(e.per) !== 2 && Number(e.per) !== 3) {
    if (e.type == 'number' && (e.max || e.min) && (value || value == 0)) {
      //如果是数字，并且配置了数字可输入范围
      if ((e.max && value > e.max) || (e.min && value < e.min)) {
        return 'delClassName delClass';
      }
    }

    if (isOne && e.idCardValid && ((e.required !== 'required' && value) || e.required === 'required')) {
      // 身份证格式
      if (value && value.length === 18) {
        if (isCardID(value) !== true) return 'delClassName delClass';
      } else {
        if (!isCardIDTwo(value)) return 'delClassName delClass';
      }
    }

    if (e.required === 'required' && isOne) {
      if ((!value && value !== 0) || value.length === 0) {
        return 'delClassName delClass';
      }
    }
    return 'delClassName';
  }
  //最大最小值
  if (isOne && e.type !== 'radio') {
    // 数字输入框没限制最大最小值
    if (!e.miniunm && !e.sizeLimit){
      if (e.required === 'required' && !value) {
        return 'delClassName delClass';
      }
      return 'delClassName';
    }
    else if (e.miniunm && e.miniunm !== 0 && value && value.length < e.miniunm && e.miniunm !== '-Infinity' ||
      e.miniunm && e.miniunm !== 0 && !value && e.miniunm !== '-Infinity' ||
      e.sizeLimit && e.sizeLimit !== 0 && value && value.length > e.sizeLimit && e.sizeLimit !== 'Infinity' ||
      e.onlyTitle && onlyTitle) {
        return 'delClassName delClass';
      }
  }

  // 单选-其他 条件满足时不能为空
  if (e.type === 'radio' && e.others && value === 'others其他' && typeof othersVal === 'string' && !othersVal && isOne) {
    return 'delClassName delClass';
  }
  //- 文本控件新增正则判断显示
  if (e.per == 1 || !e.per) {
    if (e.regularObj && e.regularObj.val === true && e.type == 'text' && isOne) {
      //- 说明该文本控件有设置正则效验
      let regularObjSetting = e.regularObj.setting
      if (regularObjSetting.region === 1) {
        //- 常规效验
        // let rules = eval(regularObjSetting.rulesVal);
        // if( !( rules.test(value) ) ){
        // 	return 'delClassName delClass';
        // }

        let findIdx = normalType.rules.findIndex(findItem => {
          return findItem.id === regularObjSetting.rulesVal

        })
        if (findIdx != -1 && value) {
          let rules = eval(normalType.rules[findIdx].val);

          if (!(rules.test(value))) {
            //- 常规效验失败
            return 'delClassName delClass';
          }
        }


      } else {
        //- 身份证效验
        if (othersVal) {
          let formVal = othersVal[regularObjSetting.rulesVal];
          let findIdx = numberCardType.rules.findIndex(findItem => {
            return findItem.name === formVal

          })
          if (value && formVal && findIdx != -1) {
            if (numberCardType.rules[findIdx].name === '中国居民身份证') {
              //- 产品改需求，身份证需要严格处理
              let whether = isCardID(value)
              if (whether !== true) {
                return 'delClassName delClass';
              }
            } else {
              let rules = eval(numberCardType.rules[findIdx].val);
              if (!(rules.test(value))) {
                //- 身份证效验失败
                return 'delClassName delClass';


              }

            }

          }

        }

      }
    }
  }
  return 'delClassName';
}

//返回头部标签的css
export function returnAllTopStyle (val) {
  let str = '<style>' +
    'html,body,#app{height:100%;}' +
    val +
    '</style>';
  return str;
}

// 显示星期几
export function getWeek(time) {
  let date = null;
  try {
    date = new Date(time)
  } catch (e) {
    return time
  }
  const week = ['日', '一', '二', '三', '四', '五', '六'];
  return week[date.getDay()];
}
